module.exports = ".btn-mob{\r\n    width: 100%;\r\n    margin-bottom: 20px;\r\n}\r\n.table thead th {\r\n    vertical-align: bottom;\r\n    border-bottom: 0px solid #eceeef;\r\n    font-weight: 600;\r\n}\r\n.table th, .table td {\r\n    padding: 0.75rem;\r\n    vertical-align: top;\r\n    border-top: 0px solid #eceeef;\r\n}\r\n.btn-mob-top{\r\n    width: 100%;\r\n    margin-bottom: 0px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/search/cost-category/cost-category.component.css
// module id = ./src/app/modules/search/cost-category/cost-category.component.css
// module chunks = main